import { HttpClient } from '@/common/helpers';
import { BackendService } from '@/types/BackendService';

function DeviceService() {
	return {
		getDevice: (uid: string) => {
			return HttpClient(BackendService.Realtime).get(`/devices/${uid}`);
		},
		getAllDevice: (company: string) => {
			return HttpClient(BackendService.Realtime).get('/devices', {
				params: {
					company: company,
				},
			});
		},
        createDevice: (values: any) => {
			return HttpClient(BackendService.Realtime).post('/devices/', values);
		},
        updateDevice: (values: any, uid: string) => {
			return HttpClient(BackendService.Realtime).put(`/devices/${uid}`, values);
		},
        deleteDevice: (uid: string) => {
			return HttpClient(BackendService.Realtime).delete(`/devices/${uid}`);
		},
		getAllDevicesAdmin: () => {
			return HttpClient(BackendService.Realtime).get('/admin/devices');
		},
	};
}

export default DeviceService();
